





































import { Vue, Component, PropSync } from 'vue-property-decorator';
@Component
export default class TaskFilter extends Vue {
  @PropSync('name') nameSync!: any;
}
